import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { WaremaIcon } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-rating-stars',
    templateUrl: './rating-stars.component.html',
    styleUrls: ['./rating-stars.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WaremaIcon],
})
export class RatingStarsComponent {
    public readonly ratingCount = input.required<number>();
    public readonly ratingStars = input.required<number>();

    public readonly starIcons = computed<Array<string>>(() => {
        const ratingStarsVal = this.ratingStars();
        const fullStars = Math.floor(ratingStarsVal);

        // init with full size + add full stars
        const result = new Array<string>(this._displayStars).fill('starFilled', 0, fullStars);
        let nextInsertIndex = fullStars;

        // add partial star
        const partialStarValue = Number.parseFloat((ratingStarsVal - fullStars).toFixed(1));
        if (partialStarValue > 0) {
            let partialStarIcon: string | null = null;
            if (partialStarValue >= 0.7) {
                partialStarIcon = 'starFilledThreeQuarter';
            } else if (partialStarValue >= 0.4) {
                partialStarIcon = 'starFilledHalf';
            } else if (partialStarValue >= 0.1) {
                partialStarIcon = 'starFilledQuarter';
            }
            if (partialStarIcon != null) {
                result[nextInsertIndex] = partialStarIcon;
                nextInsertIndex++;
            }
        }

        // add empty stars if necessary
        const addEmptyStars = this._displayStars - nextInsertIndex;
        if (addEmptyStars > 0) {
            result.fill('star', nextInsertIndex, nextInsertIndex + addEmptyStars);
        }

        return result;
    });

    private readonly _displayStars = 5;
}
